module.exports = __webpack_public_path__ + "img/car.e2f0fae.svg";